import {GetListReviewsService, GetListReviewsByDateService} from "../Infrastructure/Business.service";

export async function GetListReviewsLogic(id){
  return await GetListReviewsService(id);
}

export async function GetListReviewsByDateLogic(id, date){
  return await GetListReviewsByDateService(id, date);
}